export default __webpack_public_path__ + "static/media/university_of_ioannina.dbeb5fa8.jpg";